/**
 * One lock between the end of a session and the start of the next (Codex on
 * #1134). The session wipe empties the secure store; a sign-in that completes
 * meanwhile writes its new session there. Checking for a new session before
 * the clear is not enough on its own: the write can land between the check
 * and the clear. So the wipe, from its first check to its clear, and every
 * session write of the native auth adapter run one at a time: a write either
 * lands first, and the wipe sees it and stops, or waits until the clear is
 * done.
 *
 * Nothing run under the lock may write a session itself, or it would wait on
 * itself. No imports: the auth adapter loads before most modules.
 */
let chain: Promise<unknown> = Promise.resolve();

export function underSessionStoreLock<T>(task: () => Promise<T>): Promise<T> {
  const run = chain.then(task);
  chain = run.catch(() => undefined);
  return run;
}
